import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";
import { Options } from "./SelectOptions";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    street: string,
    postalCode: string,
    city: string,
    additionalNotes: string,
    becomingAwareThrough: string,
    becomingAwareThroughOther: string,
    fieldOfLocation: CheckboxField[],
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    displayValue:string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName: string;
    displayValue: string;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string,displayValue: string){
        this.displayName = displayName;
        this.displayValue=displayValue;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
        
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    firstName: string = "";
    lastName: string = "";
    street: string = "";
    postalCode: string = "";
    city: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    becomingAwareThrough: string="";
    becomingAwareThroughOther: string="";
    fieldOfLocation: CheckboxField[] = Options.PreferredLocation.map((field) => {
        return new CheckboxField(field.text,field.value);
    });
    additionalNotes: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "street", value: this.street },
            { name: "postalCode", value: this.postalCode },
            { name: "city", value: this.city },
            { name: "fieldOfLocation", value: this.fieldOfLocation.filter((field) => field.value === true).map((field) => field.displayValue).join(',')},
            { name: "additionalNotes", value: this.additionalNotes },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "becomingAwareThroughOther", value: this.becomingAwareThroughOther }
            );

        return application;
    }
}
